// List of hobbies and interests — club categories (match nav bar) + Politics & Civics
export const hobbies = [
  'All Clubs',
  'Arts & Culture',
  'Sports',
  'Volunteering',
  'Social & Community',
  'Business',
  'Games',
  'Travel',
  'International',
  'Hobbies & Crafts',
  'Learning & Discussion',
  'Faith & Spirituality',
  'Politics & Civics',
];

// Single category group for the Hobbies dropdown
export const hobbiesByCategory = {
  'Club Categories': [
    'All Clubs',
    'Arts & Culture',
    'Sports',
    'Volunteering',
    'Social & Community',
    'Business',
    'Games',
    'Travel',
    'International',
    'Hobbies & Crafts',
    'Learning & Discussion',
    'Faith & Spirituality',
    'Politics & Civics',
  ],
};
